<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import {
		companyPath
	} from '@/api'
	import s from "./config/sj.js"
	export default {
		onLaunch: function() {
			// if (this.$wechat.isWechat()=='isWechat') {
			// 	uni.setStorageSync('lang', this.getparams().lang)
			// 	uni.setStorageSync('access_token', this.getparams().access_token)
			// 	uni.setStorageSync('refresh_token', this.getparams().refresh_token)
			// 	uni.setStorageSync('token_access_token_exprie', this.getparams().token_access_token_exprie)
			// 	// 初始化扫码
			// 	this.$wechat.initJssdk()
			// }
		},
		onShow: function() {
			// console.log('App Show')
			// uni.webView.getEnv((res) => {
			// 	let result
			// 	if (res.plus) {
			// 		result = plus.storage.getItem('lang');
			// 	} else {
			// 		result = uni.getStorageSync('lang')
			// 	}
			// 	this.$i18n.locale = String(result) 
			// });
		},
		onHide: function() {
			console.log('App Hide')
		},
		methods: {
			UrlSearch() {
				var name, value;
				var str = location.href; //取得整个地址栏
				var num = str.indexOf("?")
				str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]
				var arr = str.split("&"); //各个参数放到数组里
				for (var i = 0; i < arr.length; i++) {
					num = arr[i].indexOf("=");
					if (num > 0) {
						name = arr[i].substring(0, num);
						value = arr[i].substr(num + 1);
						this[name] = value;
					}
				}
			},
			getparams() {
				var name, value;
				var str = location.href; //取得整个地址栏
				var num = str.indexOf("?")
				str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
				let obj = {}
				var arr = str.split("&"); //各个参数放到数组里
				for (var i = 0; i < arr.length; i++) {
					num = arr[i].indexOf("=");
					if (num > 0) {
						name = arr[i].substring(0, num);
						value = arr[i].substr(num + 1);
						obj[name] = value;
					}
				}
				return obj
			}

		}
	}
</script>

<style lang="scss">
	/* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
	@import "@/uni_modules/uview-ui/index.scss";
	// 设置整个项目的背景色和字体大小
	page {
		background-color: #f5f5f5;
	}
	
	.example-info {
		font-size: 12px;
		color: #333;
		padding: 10px;
	}
	
	// footer按钮
	.handle-btn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		height: 120rpx;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background-color: #FFF;
		margin-top: 30rpx;
	 
		.finish-btn {
			font-size: 26rpx;
			width: 200rpx;
		}
	}
	body{
			line-height: 1.8;
	}
	
	
</style>